export const adminLteConf = {
	skin: 'transporte',
	sidebarLeftMenu: [
		{
			label: 'Consulta DUT',
			route: '/',
			iconClasses: 'fa fa-home',
			ConsultaDut: true,
		},
		// {label: 'Consulta Serv en Viaje', route: '/viaje-consultas', iconClasses: 'fa fa-search'},
		{
			label: 'Selección Empresa',
			route: 'empresas',
			iconClasses: 'fa fa-id-card',
			permisos: ['USER'],
			empresas: true,
		},
		{
			label: 'Portal Empresa',
			route: 'portalEmrpesas',
			iconClasses: 'fa fa-building-o',
			portalEmpresa: true,
		},

		{
			label: 'Nuevo DUT',
			route: 'nuevo DUT',
			iconClasses: 'fa fa-bus',
			nuevoDut: true,
		},

		{
			label: 'Cuadro Horario',
			route: 'cuadro',
			iconClasses: 'fa fa-calendar-o',
			cuadroHorario: true,
		},
		{
			label: 'Consultas',
			route: '/admin',
			iconClasses: 'fa fa-search',
			roles: ['ADMIN'],
		},
		{
			label: 'Tableros',
			iconClasses: 'fa fa-bar-chart',
			permisos: ['USER'],
			children: [{ label: 'DUT', route: 'empresas/0/tablero', permisos: ['USER'] }],
		},
		{
			label: 'RPV CNRT',
			route: '',
			iconClasses: 'fa fa-id-card',
			permisos: ['USER'],
			empresas: true,
		},
	],
};
